import { Component } from '@angular/core';
import { SidebarUiService } from '../sidebar-ui.service';
import { LanguageService } from '../../language.service';

// New-design sidebar chrome (logo, mobile drawer, docpanel); the page nav is projected via <ng-content>.
@Component({
  selector: 'app-new-sidebar',
  templateUrl: './new-sidebar.component.html',
  styleUrls: ['./new-sidebar.component.scss'],
  standalone: false,
})
export class NewSidebarComponent {
  constructor(
    public ui: SidebarUiService,
    private languageService: LanguageService
  ) {}

  // Writing direction follows the interface language so Hebrew/Arabic align right.
  get dir(): 'rtl' | 'ltr' {
    return this.languageService.pageDirection();
  }
}
